import { render, staticRenderFns } from "./PostTuitionFeeDialog.vue?vue&type=template&id=2ea383f8"
import script from "./PostTuitionFeeDialog.vue?vue&type=script&lang=js"
export * from "./PostTuitionFeeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports